import type { SxProps } from "@mui/material"
import { gridClasses } from "@mui/x-data-grid"

import {
  GRAY_COLOR,
  GRID_HEADER_ITEM,
  NOTIFICATION_ICONS_ACTIVE,
  NOTIFICATION_ICONS_OFF,
  PRIMARY,
  SMS_ICON,
  WATSAPP_ACTIVE
} from "@constants/colors"

const gridBox: SxProps = {}

const gridContainer: SxProps = {
  border: 0,
  "& .MuiDataGrid-scrollbar--horizontal": {
    overflow: "visible!important"
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: "none"
  },
  [`& .${gridClasses.row}:focus, & .${gridClasses.row}:focus-within, & .${gridClasses.row}:hover`]:
    {
      backgroundColor: "transparent !important"
    },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: "none"
    }
}

const headerItems: SxProps = {
  color: GRID_HEADER_ITEM
}
const whatsappActiveIcon: SxProps = {
  cursor: "pointer",
  color: WATSAPP_ACTIVE,
  height: "1.1rem"
}
const smsIcon: SxProps = {
  cursor: "pointer",
  color: SMS_ICON,
  height: "1.1rem"
}
const renderCellIconBox: SxProps = {
  display: "flex",
  gap: 0.5,
  cursor: "pointer",
  fontWeight: "bold"
}
const notificationsOffIcon: SxProps = {
  cursor: "pointer",
  color: NOTIFICATION_ICONS_OFF,
  height: "1.1rem"
}
const notificationsActiveIcon: SxProps = {
  cursor: "pointer",
  color: NOTIFICATION_ICONS_ACTIVE,
  height: "1.1rem"
}

const optionContainer: SxProps = {
  display: "flex",
  cursor: "pointer",
  color: GRAY_COLOR,
  height: "1.1rem"
}

const optionContainerActive: SxProps = {
  display: "flex",
  cursor: "pointer",
  color: PRIMARY,
  height: "1.1rem"
}

const popOverOption: SxProps = {
  padding: 1,
  pr: 9,
  cursor: "pointer",
  "&:hover": {
    background: "#F1F1F1"
  }
}

export default {
  gridBox,
  gridContainer,
  headerItems,
  whatsappActiveIcon,
  smsIcon,
  renderCellIconBox,
  notificationsOffIcon,
  notificationsActiveIcon,
  optionContainer,
  optionContainerActive,
  popOverOption
}
